export enum DataFormat {
  Percent = "Percent",
  Year = "Year",
  Month = "Month",
  Hour = "Hour",
  Boolean = "Boolean",
}
